import Link from 'next/link'
import { FaChevronRight, FaChevronLeft } from 'react-icons/fa'

const path = "/learn-and-earn/"

function Nav(props) {
    return (
        <>
            <div className="bg-light-gray d-flex justify-content-between p-3">
                <Link href={`${path}${props.backlink}`} passHref><a className="text-reset text-decoration-none"><FaChevronLeft/> <span className="d-md-inline-block d-none">BACK</span></a></Link>
                <p className="text-uppercase mb-0 moduleTitle">Module {props.module} - {props.title}</p>
                <Link href={`${path}${props.nextlink}`} passHref><a className="text-reset text-decoration-none"><span className="d-md-inline-block d-none">FWD</span> <FaChevronRight/></a></Link>
            </div>
            <style jsx>{`
                @media(max-width:767px){
                    .moduleTitle{
                        text-align: center;
                    }
                }
            `}</style>
        </>
    )
}

export default Nav
